import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { manualApi } from '../../api/global';
import TotalManualItem from './TotalManualItem';
import AlertModal from '../common/AlertModal';
import ConfirmModal from '../common/ConfirmModal';
import FilterSearch from './FilterSearch';

function TotalManualList({
  totlaManuals,
  myManualsIdxs = [],
  setTotalManuals,
  reload,
}) {
  const [alertModal, setAlertModal] = useState(false);
  const [deleteModalOpenId, setDeleteModalOpenId] = useState(null);
  const [isAdding, setIsAdding] = useState(false);

  const handleAddnRemoveBtnClick = async manual => {
    try {
      const isMine = myManualsIdxs?.some(item => item.book_idx === manual.idx);
      // 내 교재에 없으면 내 교재에 추가
      if (!isMine) {
        setIsAdding(true);
        const { status } = await manualApi.addMyManual({
          bookIdx: manual.idx,
          order: myManualsIdxs?.length + 1,
        });
        if (status === 200) {
          setAlertModal(true);
          reload();
        }
      }
      // 내 교재이 있으면 내교재에서 해재
      else {
        setDeleteModalOpenId(manual.idx);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsAdding(false);
    }
  };

  // 나의교재 삭제 이벤트
  const deleteMyManual = async () => {
    try {
      const target = myManualsIdxs?.find(m => m.book_idx === deleteModalOpenId);
      const { status } = await manualApi.deleteMyManual(target.myBook_idx);
      if (status === 200) {
        reload();
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="h-full w-full flex flex-col items-start justify-start">
      <div className="w-full h-full bg-[#F1F5F9] py-[16px] flex flex-col items-start justify-center">
        <div className="px-[30px] pb-[20px]">
          <FilterSearch
            location="total"
            setManuals={setTotalManuals}
            reload={reload}
          />
        </div>
        {totlaManuals?.length >= 1 ? (
          <div className="grow overflow-y-scroll w-full grid grid-cols-7 grid-rows-[minmax(300px,300px)] gap-y-[40px] gap-x-[12px] px-[30px] justify-start items-start">
            {totlaManuals.map(manual => {
              const isMine = myManualsIdxs.some(
                item => item.book_idx === manual.idx,
              );
              return (
                <TotalManualItem
                  key={manual.idx}
                  manual={manual}
                  onAddnRemoveBtnClick={handleAddnRemoveBtnClick}
                  isMine={isMine}
                  isAdding={isAdding}
                />
              );
            })}
          </div>
        ) : (
          <div className="w-full h-full flex justify-center items-center text-[#383C4B] font-[16px] font-[400]">
            검색 결과가 없습니다.
          </div>
        )}
      </div>
      <AlertModal
        open={alertModal}
        setOpen={setAlertModal}
        content="나의 교재로 추가되었습니다."
        confirmLabel="확인"
        onConfirm={() => setAlertModal(false)}
      />
      <ConfirmModal
        open={deleteModalOpenId === null ? false : true}
        setOpen={setDeleteModalOpenId}
        content={`나의 교재에서 삭제됩니다.\n삭제 시 저장된 시험지 목록도 함께 삭제됩니다.\n정말 삭제하시겠습니까?`}
        cancelLabel="취소"
        confirmLabel="삭제"
        onCancel={() => setDeleteModalOpenId(null)}
        onConfirm={deleteMyManual}
      />
    </div>
  );
}

TotalManualList.propTypes = {
  totlaManuals: PropTypes.arrayOf(PropTypes.object).isRequired,
  myManualsIdxs: PropTypes.arrayOf(PropTypes.object),
  setTotalManuals: PropTypes.func.isRequired,
  reload: PropTypes.func.isRequired,
};

export default TotalManualList;
